import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { Guard } from '../../components/layout/Guard';

const MastersPage = lazy(() => import('./MastersPage'));
const VendorDetailPage = lazy(() => import('./VendorDetailPage'));

const routes: RouteObject[] = [
  { path: '/masters', element: <Guard any={['master.read', 'master.write']}><MastersPage /></Guard> },
  // approval links from the inbox land here (adapter route /masters/vendors + vendor number)
  { path: '/masters/vendors/:id', element: <Guard any={['master.read', 'master.write']}><VendorDetailPage /></Guard> },
];
export default routes;
